import { render, staticRenderFns } from "./coc-data-suggest-result-side-action.vue?vue&type=template&id=66ec538a"
import script from "./coc-data-suggest-result-side-action.ts?vue&type=script&lang=js&external"
export * from "./coc-data-suggest-result-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports